<template>
  <div class="sm-select" :class="{ 'sm-select--invalid': invalid }">
    <label v-if="label" class="sm-select__label" :for="inputId">{{ label }}</label>
    <div class="sm-select__wrap">
      <select
        :id="inputId"
        class="sm-select__control"
        :value="value"
        :disabled="disabled"
        @change="$emit('input', $event.target.value)"
      >
        <option v-if="placeholder" value="" disabled>{{ placeholder }}</option>
        <option
          v-for="opt in options"
          :key="optValue(opt)"
          :value="optValue(opt)"
        >{{ optLabel(opt) }}</option>
      </select>
      <i class="sm-select__chevron fas fa-chevron-down"></i>
    </div>
  </div>
</template>

<script>
let uid = 0
export default {
  name: 'AppSelect',
  model: { prop: 'value', event: 'input' },
  props: {
    value: { type: [String, Number], default: '' },
    options: { type: Array, default: () => [] },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    invalid: { type: Boolean, default: false },
    // item может быть строкой или объектом
    optionValue: { type: [String, Function], default: '' },
    optionLabel: { type: [String, Function], default: '' },
    labelPosition: { type: String, default: 'top' } // top | inline
  },
  data() {
    return { inputId: `sm-select-${++uid}` }
  },
  methods: {
    optValue(opt) {
      if (typeof opt === 'object') {
        return this.optionValue
          ? (typeof this.optionValue === 'function' ? this.optionValue(opt) : opt[this.optionValue])
          : opt.value
      }
      return opt
    },
    optLabel(opt) {
      if (typeof opt === 'object') {
        return this.optionLabel
          ? (typeof this.optionLabel === 'function' ? this.optionLabel(opt) : opt[this.optionLabel])
          : (opt.label !== undefined ? opt.label : opt.value)
      }
      return opt
    }
  }
}
</script>

<style scoped>
.sm-select__label {
  display: block;
  font-size: var(--text-xs);
  font-weight: var(--font-weight-semibold);
  color: var(--text-secondary);
  margin-bottom: var(--space-2);
}

.sm-select__wrap { position: relative; }

.sm-select__control {
  width: 100%;
  padding: var(--space-4) var(--space-8);
  padding-right: var(--space-20);
  border-radius: var(--radius-input);
  border: var(--border-width-default) var(--border-style-base) var(--border-default);
  font-size: var(--text-base);
  font-family: inherit;
  background: var(--bg-input);
  color: var(--text-primary);
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  transition: border-color var(--duration-fast) var(--ease-base),
              background var(--duration-fast) var(--ease-base),
              box-shadow var(--duration-normal) var(--ease-out);
}

.sm-select__control:hover:not(:focus):not(:disabled) { border-color: var(--border-strong); }

.sm-select__control:focus {
  outline: none;
  border-color: var(--border-focus);
  background: var(--bg-surface);
  box-shadow: var(--focus-ring);
}

.sm-select__control:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.sm-select--invalid .sm-select__control {
  border-color: var(--danger);
}

.sm-select__chevron {
  position: absolute;
  right: var(--space-8);
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-tertiary);
  font-size: var(--text-xs);
  pointer-events: none;
}
</style>
